import React from 'react';
import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons';
import { useSidebarStore } from '../../../stores/sidebar-store';
import { cn } from '../../../utils';
import { Icon } from '../../ui/icon';

interface AppSidebarTogglerProps {
  className?: string;
}

export function AppSidebarToggler({ className }: AppSidebarTogglerProps) {
  const { isCollapsed, toggleCollapsed } = useSidebarStore();

  return (
    <button
      id="sidebar-button-collapse"
      onClick={toggleCollapsed}
      className={cn(
        'tw-flex tw-items-center tw-rounded-md tw-transition-all tw-duration-300 tw-ease-in-out hover:tw-bg-gray-50 tw-w-full',
        isCollapsed ? 'tw-justify-center' : 'tw-gap-2',
        className
      )}
      style={{
        fontSize: '14px',
        fontWeight: 400,
        color: '#1f1f1f',
        lineHeight: 1,
        paddingTop: '8px',
        paddingBottom: '8px',
        paddingLeft: '12px',
        paddingRight: '12px',
      }}
    >
      <Icon
        icon={faChevronLeft}
        className={cn(
          'tw-flex-shrink-0 tw-transition-transform tw-duration-300 tw-ease-in-out',
          isCollapsed && 'tw-rotate-180'
        )}
        style={{
          width: '16px',
          height: '16px',
          minWidth: '16px',
          minHeight: '16px',
        }}
      />
      <span
        className={cn(
          'tw-whitespace-nowrap tw-transition-all tw-duration-300 tw-ease-in-out',
          isCollapsed
            ? 'tw-opacity-0 tw-max-w-0 tw-overflow-hidden'
            : 'tw-opacity-100 tw-max-w-full'
        )}
      >
        Collapse
      </span>
    </button>
  );
}
